/**
 * Error used when a media fragment failed to load.
 */
export class FragmentError extends Error {
    /**
     * Represents a storage resolution error.
     *
     * @param code - The error code.
     * @param message - The error message.
     * @param status - The status number.
     * @param debug - Helper object for debugging.
     */
    constructor(code, message, status, debug = {}) {
        super(message);
        this.code = code;
        this.message = message;
        this.status = status;
        this.debug = debug;
        this.name = 'FragmentError';
    }
}
//# sourceMappingURL=fragment.js.map